export default __webpack_public_path__ + "static/hvac-service-repair-minnesota-b592b80b7599a3296e019d9f37930d07.jpg";